import { useContext, useEffect, useState } from "react";
import TELAS from "../../constants/telas";
import usePermissoesState from "../../hooks/usePermissoesState";
import Application from "../../components/application";
import GridView from "../../components/views/gridView";
import { Button, Tooltip } from "@mui/material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { AuthContext } from "../../contexts/auth";
import ModalPermissaoUsuario from "./modalPermissaoUsuario";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import TELA_ACOES from "../../constants/telaAcoes";
import permissaoTelas from "../../utils/permissaoTelas";


const PAGINA = {
    aplicacao: 'SisPalo - Gestor',
    funcionalidade: 'Gestor',
    tela: TELAS.PERMISSOES,
    acoes: [TELA_ACOES.Alterar,TELA_ACOES.Consultar]
}

const Permissoes = () => {

    const states = usePermissoesState()
    const [nomeUsuario, setNomeUsuario] = useState('')
  
    const {permissaoUsuario} = useContext(AuthContext); 
       

    useEffect(()=>{
        states.submit.set()
    }, [])

    const columns = [
            {field:'name', headerName:'Nome dos Usuários', flex: 1},
            {field:'numero_permissoes', headerName:'', width: 50, renderCell: (cellValues) =>{
                return (
                    <Tooltip title="Tem Permissões" placement="bottom" arrow>
                            {
                                cellValues.row.numero_permissoes ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                            }
                    </Tooltip>                
                    )
                }
            },
            {field:' ', headerName:'Ações', width:110, renderCell: (cellValues) =>{
                return (
                    <>
                        <Tooltip title="Fornecer Permissão" placement="bottom" arrow>
                                <Button onClick={() => {
                                    states.openModalPermissoes.set(cellValues.row.id)
                                    setNomeUsuario(cellValues.row.name)
                                }} 
                                        sx={{width:'55px', padding: 0,minWidth:0}}
                                        disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)}
                                        ><AssignmentTurnedInIcon/>
                                </Button>
                        </Tooltip>                
                 
                    </>
                    
                )
            }}
        ]

    const onFinalizar = async () => {
        await states.permissoes.set()
    }

    return (
        <Application>
            <> 
                <GridView 
                    title='Permissões de Usuário' 
                    states={states}
                    rows={states.usuarios.value}
                    columns={columns}
                    urlAdd={null}
                    urlVoltar={'/gestor/dashboard'}                    
                    onClickPesquisa={()=>{states.submit.set()}}
                    nomeItem='Usuário'
                    children={null}
                    modalAdd={null}
                />
                <ModalPermissaoUsuario 
                    open={states.openModalPermissoes.value > 0} 
                    onClose={() => states.openModalPermissoes.set(0)} 
                    onFinalizar={onFinalizar} 
                    permissoes={states.permissoes.value} 
                    nomeUsuario={nomeUsuario}
                    permissoesDoUsuario={states.permissoesDoUsuario}
                    submit={states.submit.value}
                />
            </>
        </Application>
   

    )

}

export default Permissoes;